import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../Containers/Config/index.js';
import { GET_BOOKING_TYPE, GET_BOOKING_TYPE_SUCCESS, GET_BOOKING_TYPE_ERROR } from '../actions';
import apiCall from '../../apiCall';

function* getBookingType({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/get-dashboard-data`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_BOOKING_TYPE_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_BOOKING_TYPE_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_BOOKING_TYPE_ERROR, payload: error });
  }
}

export function* watchBookingType() {
  yield takeEvery(GET_BOOKING_TYPE, getBookingType);
}

function* watchBookingTypeSaga() {
  yield all([fork(watchBookingType)]);
}

export default watchBookingTypeSaga;
